import { aabb2AddPoint, aabb2New } from "geom/aabb2";
import * as THREE from "three";

const tmpVec = new THREE.Vector3();

export function NDCBoundingBox(
  root: THREE.Object3D,
  camera: THREE.Camera,
  excludeObject?: (obj: THREE.Mesh) => boolean,
) {
  const bb = aabb2New(Infinity, Infinity, -Infinity, -Infinity);
  root.traverse((obj) => {
    if (obj instanceof THREE.Mesh && (excludeObject === undefined || !excludeObject(obj))) {
      const geometry = obj.geometry as THREE.BufferGeometry;
      const position = geometry.getAttribute("position") as THREE.BufferAttribute;

      // This ignores the index buffer and assumes that all the entries in the position buffer are used.
      const array = position.array;
      const stride = position.itemSize;
      for (let i = 0, l = position.count; i < l; ++i) {
        tmpVec.set(array[i * stride], array[i * stride + 1], array[i * stride + 2]);
        tmpVec.applyMatrix4(obj.matrixWorld);
        tmpVec.project(camera);
        aabb2AddPoint(bb, tmpVec.x, tmpVec.y);
      }
    }
  });
  return bb;
}
